<template>
  <p-secure :require-role="[SECURITYROLES.STOREMANAGER]">
    <b-overlay :show="isBusy" no-center>
      <template #overlay>
        <b-spinner class="centered-spinner" />
      </template>
      <p-search-screen
        title="Customers"
        api-destination="customers"
        :filters="filters"
        :fields="fields"
        :filter-by="filterBy"
        edit-key="customerId"
        add-new-button
        @selected="onSelection"
        @selected-rows-changed="selectedRowsChanged"
        :use-bootstrap-selection="false"> <!-- Enable the selection checkboxes -->
        <template v-slot:actionButtons>
          <b-dropdown
            :is-busy="isBusy"
            text="Exports"
            variant="outline-primary">
              <b-dropdown-item @click="exportCustomerDetails(true)" :disabled="selectedCustomers.length <= 0">
                Selected Customer Details (CSV)
              </b-dropdown-item>
              <b-dropdown-item @click="exportCustomerDetails(false)">
                All Customer Details (CSV)
              </b-dropdown-item>            
          </b-dropdown>
        </template>
        <template v-slot:cell(fullName)="{ item }">
          {{item.lastName}}
        </template>
      </p-search-screen>
    </b-overlay>
  </p-secure >
</template>

<script>

import {dateFormatter} from '../../components/Common/Formatters.js';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';

export default {
  mixins: [SearchStorage],
  data() {
    return {
      selectedCustomers: [],
      filterName: 'CustomerFilter',
      isBusy: false,
      filters: {
        automatic: "",
        perPage: 100,
        sortBy: 'fullName',
        sortDesc: false,
        searchBy:'All',
        selectedIds: null        
      },
      filterExclude: [
        'selectedIds' // Do not save selectedIds in local storage
      ],       
      filterBy:[
          'All',
          'Account #',
          'Student ID',
          'Alternate Lookup ID',
          'Phone #',
          'Last Name',
          'Email'
      ],
      fields: [
      {
          label: 'Account Number',
          key: "number",
          sortable: true
        },
        {
          //use fullName to achieve lastname then firstname sorting,
          //will override the text to only show last name
          label: "Last Name",
          key: "fullName",
          sortable: true
        },
        {
          key: "firstName"
        },
        {
          label: 'Student ID',
          key: "studentAccount",
          sortable: true
        },
        {
          key: "phone"
        },
        {
          key: "email",
          sortable: true
        },
        {
          key: "lastTransactionDate",
          formatter: dateFormatter
        },
      ]
    };
  },
  methods: {
      onSelection(customers) {
        this.selectedCustomers = customers;
      },
      selectedRowsChanged(selectedCustomers) {
        this.onSelection(selectedCustomers);
      },
      async exportCustomerDetails(selectedCustomers) {
        if(!selectedCustomers) {
          const proceed = await this.$bvModal
            .msgBoxConfirm(
              'Note that if you have a large number of customers (5K+) this may take some time to export. Do you want to continue?',
              {
                  title: 'Export All Customer Details',
                  size: 'md',
                  buttonSize: 'md',
                  okVariant: 'primary',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              });

              if (!proceed) {
                return;
              }
        }

        this.isBusy = true;
        // Make a copy of the filters so the export selections do not affect the UI
        let exportFilters = { ...this.filters };
        if (selectedCustomers) {
          exportFilters.selectedIds = this.selectedCustomers?.map(customer => customer.customerId);
        } 
        else {
          exportFilters.selectedIds = null;
          exportFilters.automatic = null;
          exportFilters.searchBy = null;
        }        
  
        axios.post('/customers/exportcustomerdetails', exportFilters, { responseType: 'blob' })
          .then(result => {
            downloadFileToBrowser(
              result.data,
              'CustomerDetails.csv',
              'application/csv');

              this.$appSuccess('Customer Details CSV file generated successfully.')
            })
            .finally(() => {
              this.isBusy = false;
              this.filters.selectedIds = null;
            });
      },        
    }  
};
</script>

<style scoped lang="scss">
  @import '@/styles/app/common/variables.scss';
 
  :deep(.centered-spinner ) {
    margin-top: 10%;
    margin-left: 50%;
  }
</style>